import baseTheme from "theme";
import sohoSkinTheme from "sohoSkinTheme";
import { BOOKING_THEMES } from "utils/constants";

/**
 * Theme registry for managing different application themes
 */
export const THEME_REGISTRY = {
  [BOOKING_THEMES.DEFAULT.id]: baseTheme,
  [BOOKING_THEMES.SOHO.id]: sohoSkinTheme,
};

/**
 * Gets theme object by theme ID
 * @param {string} themeId - The theme identifier
 * @returns {object} Material-UI theme object
 */
export const getThemeById = (themeId) => {
  return THEME_REGISTRY[themeId] || THEME_REGISTRY[BOOKING_THEMES.DEFAULT.id];
};

/**
 * Redux selector for current theme object
 * @param {object} state - Redux state
 * @returns {object} Current theme object
 */
export const selectCurrentTheme = (state) => {
  const themeId = state.booking.appTheme;
  return getThemeById(themeId);
};

/**
 * Redux selector for current theme ID
 * @param {object} state - Redux state
 * @returns {string} Current theme ID
 */
export const selectCurrentThemeId = (state) => {
  return state.booking.appTheme || BOOKING_THEMES.DEFAULT.id;
};

/**
 * Check if current theme is Soho theme
 * @param {object} state - Redux state
 * @returns {boolean} True if current theme is Soho
 */
export const selectIsSohoTheme = (state) => {
  return selectCurrentThemeId(state) === BOOKING_THEMES.SOHO.id;
};

export const preserveThemeInQueryParams = (searchParams) => {
  const preservedParams = {};
  if (searchParams.bookingTheme) {
    preservedParams.bookingTheme = searchParams.bookingTheme;
  }
  return preservedParams;
};

export default {
  THEME_REGISTRY,
  getThemeById,
  selectCurrentTheme,
  selectCurrentThemeId,
  selectIsSohoTheme,
};
